import { apiFetch } from './client';

export interface AuthUser {
  username: string;
  role: string;
}

export const login = (username: string, password: string): Promise<AuthUser> =>
  apiFetch<AuthUser>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });

export const logout = (): Promise<{ ok: boolean }> =>
  apiFetch<{ ok: boolean }>('/api/auth/logout', { method: 'POST' });

export const refreshSession = (): Promise<AuthUser> =>
  apiFetch<AuthUser>('/api/auth/refresh', { method: 'POST' });

export const fetchMe = (): Promise<AuthUser> =>
  apiFetch<AuthUser>('/api/auth/me');

export const changePassword = (
  current_password: string,
  new_password: string,
): Promise<{ ok: boolean }> =>
  apiFetch<{ ok: boolean }>('/api/auth/password', {
    method: 'POST',
    body: JSON.stringify({ current_password, new_password }),
  });
